import { useDispatch, useSelector } from 'react-redux'
import { CardButton } from 'shared/ui/CardButton'
import cls from './Choosebar.module.scss'
import { memo } from 'react'
import { classNames } from 'shared/lib/classNames/classNames'
import { reviewSuggestion } from 'features/anonymousAuth/services/reviewSuggestion'

export const AdminChoosebar = memo((props) => {
    const { activeButton, onOpenFloatCollection, onOpenFloatSpeak, disabled } =
        props

    const dispatch = useDispatch()
    const currentImage = useSelector((state) => state.admin.currentImage)
    const currentText = useSelector((state) => state.admin.currentText)
    const currentSpeak = useSelector((state) => state.admin.currentSpeak)

    const onAccept = () => {
        if (!disabled && currentImage && currentText.length > 0) {
            dispatch(
                reviewSuggestion({
                    decision: 'approved',
                    direction: [1000, 0],
                })
            )
        }
    }

    const onReject = () => {
        if (!disabled) {
            dispatch(
                reviewSuggestion({
                    decision: 'rejected',
                    direction: [-1000, 0],
                })
            )
        }
    }

    return (
        <div className={classNames(cls.Choosebar, {}, [])}>
            <CardButton
                disabled={disabled}
                activeButton={activeButton}
                action={onReject}
                type="reject"
            />
            <CardButton
                disabled={disabled}
                activeButton={activeButton}
                currentSpeak={currentSpeak}
                action={onOpenFloatSpeak}
                type="speak"
            />
            <CardButton
                disabled={disabled}
                activeButton={activeButton}
                action={onOpenFloatCollection}
                type="collections"
            />
            <CardButton
                disabled={disabled}
                activeButton={activeButton}
                action={onAccept}
                type="accept"
            />
        </div>
    )
})
